import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { TabView, TabPanel } from 'primereact/tabview';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export default function ControleQualidadeDetalhe({ data, onBack }) {
    if (!data) return null;

    const { nomeDefeito, totalMetros, por_artigo = [], por_tear = [] } = data;

    const formatMetros = (val) => {
        return parseFloat(val).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const renderProgressBar = (percentual) => {
        return (
            <div style={{ width: '100%', backgroundColor: '#e9ecef', borderRadius: '4px', height: '10px' }}>
                <div style={{ width: `${percentual}%`, backgroundColor: '#d32f2f', height: '100%', borderRadius: '4px' }}></div>
            </div>
        );
    };

    const getTableData = (list) => {
        return list.map((item, index) => {
            const metros = parseFloat(item.total_metros);
            const percentual = totalMetros > 0 ? (metros / totalMetros) * 100 : 0;
            return {
                ...item,
                posicao: index + 1,
                metrosNum: metros,
                percentual: percentual
            };
        }).sort((a, b) => b.metrosNum - a.metrosNum);
    };

    const indexTemplate = (rowData) => {
        const isTop3 = rowData.posicao <= 3;
        return (
            <div style={{ 
                width: '24px', 
                height: '24px', 
                borderRadius: '50%', 
                backgroundColor: isTop3 ? '#fff9c4' : 'transparent', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                fontWeight: 'bold',
                color: isTop3 ? '#f57f17' : 'inherit'
            }}>
                {rowData.posicao}
            </div>
        );
    };

    const artigoTemplate = (rowData) => {
        return <span style={{ color: '#7b1fa2', fontWeight: 'bold', backgroundColor: '#f3e5f5', padding: '4px 8px', borderRadius: '4px' }}>{rowData.nome}</span>;
    };

    const tearTemplate = (rowData) => {
        return <span style={{ color: '#1976d2', fontWeight: 'bold', backgroundColor: '#e3f2fd', padding: '4px 8px', borderRadius: '4px' }}>{rowData.nome}</span>;
    };

    const percentualTemplate = (rowData) => {
        return `${rowData.percentual.toFixed(2)}%`;
    };

    const totalTemplate = (rowData) => {
        return <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>{formatMetros(rowData.metrosNum)}</span>;
    };

    const distribuicaoTemplate = (rowData) => {
        return renderProgressBar(rowData.percentual);
    };

    const artigosAfetados = por_artigo.length;
    const tearesEnvolvidos = por_tear.length;

    return (
        <div style={{ fontFamily: 'var(--font-family)' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
                <Button icon="pi pi-arrow-left" className="p-button-rounded p-button-text p-mr-2" onClick={onBack} title="Voltar" />
                <h4 style={{ margin: 0, color: '#6c757d', textTransform: 'uppercase', fontSize: '0.9rem' }}>TECELAGEM • CONTROLE DE QUALIDADE</h4>
            </div>

            <div style={{ backgroundColor: '#111827', color: '#fff', padding: '1.5rem', borderRadius: '8px', marginBottom: '1rem' }}>
                <h2 style={{ margin: '0 0 0.5rem 0', fontSize: '1.8rem' }}>{nomeDefeito}</h2>
                <div style={{ color: '#9ca3af', fontSize: '0.9rem' }}>Defeito acumulado • {formatMetros(totalMetros)} m total</div>
            </div>

            <div className="p-grid p-mb-3">
                <div className="p-col-12 p-md-4">
                    <Card style={{ height: '100%' }}>
                        <div style={{ color: '#6c757d', fontWeight: 'bold', fontSize: '0.8rem', marginBottom: '0.5rem', textTransform: 'uppercase' }}>TOTAL GERAL</div>
                        <div style={{ color: '#d32f2f', fontSize: '1.5rem', fontWeight: 'bold' }}>
                            {formatMetros(totalMetros)} <span style={{ fontSize: '1rem' }}>m</span>
                        </div>
                    </Card>
                </div>
                <div className="p-col-12 p-md-4">
                    <Card style={{ height: '100%' }}>
                        <div style={{ color: '#6c757d', fontWeight: 'bold', fontSize: '0.8rem', marginBottom: '0.5rem', textTransform: 'uppercase' }}>ARTIGOS AFETADOS</div>
                        <div style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>{artigosAfetados}</div>
                    </Card>
                </div>
                <div className="p-col-12 p-md-4">
                    <Card style={{ height: '100%' }}>
                        <div style={{ color: '#6c757d', fontWeight: 'bold', fontSize: '0.8rem', marginBottom: '0.5rem', textTransform: 'uppercase' }}>TEARS ENVOLVIDOS</div>
                        <div style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>{tearesEnvolvidos}</div>
                    </Card>
                </div>
            </div>

            <Card className="p-mt-3">
                <TabView>
                    <TabPanel header="Por Artigo">
                        <DataTable value={getTableData(por_artigo)} stripedRows responsiveLayout="scroll" className="p-datatable-sm">
                            <Column header="#" body={indexTemplate} style={{ width: '5%' }}></Column>
                            <Column header="ARTIGO" body={artigoTemplate} style={{ width: '20%' }}></Column>
                            <Column header="TOTAL (M)" body={totalTemplate} style={{ width: '25%' }} sortable field="metrosNum"></Column>
                            <Column header="% DO TOTAL" body={percentualTemplate} style={{ width: '20%' }} sortable field="percentual"></Column>
                            <Column header="DISTRIBUIÇÃO" body={distribuicaoTemplate} style={{ width: '30%' }}></Column>
                        </DataTable>
                    </TabPanel>
                    <TabPanel header="Por Tear">
                        <DataTable value={getTableData(por_tear)} stripedRows responsiveLayout="scroll" className="p-datatable-sm">
                            <Column header="#" body={indexTemplate} style={{ width: '5%' }}></Column>
                            <Column header="TEAR" body={tearTemplate} style={{ width: '20%' }}></Column>
                            <Column header="TOTAL (M)" body={totalTemplate} style={{ width: '25%' }} sortable field="metrosNum"></Column>
                            <Column header="% DO TOTAL" body={percentualTemplate} style={{ width: '20%' }} sortable field="percentual"></Column>
                            <Column header="DISTRIBUIÇÃO" body={distribuicaoTemplate} style={{ width: '30%' }}></Column>
                        </DataTable>
                    </TabPanel>
                </TabView>
            </Card>
        </div>
    );
}
